export const aboutData = [
  {
    image: require("../../assets/mobile/icons/bridge.png"),
    heading: "We  act as a bridge between artist and aesthete",
    paragraph:
      "We collect all our samples across the world to make it easier for an aesthete to get across a great sample.",
  },
  {
    image: require("../../assets/mobile/icons/achievement.png"),
    heading: "On top of our competitors with satisfied customers",
    paragraph:
      "We collect all our samples across the world to make it easier for an aesthete to get across a great sample.",
  },
];
